import {useMutation, useQueryClient} from "@tanstack/react-query";
import {QUERY_KEYS} from "infra/libs/react-query/queryKeys";
import {postFavoritePlace} from "../services/postFavoritePlace";
import {PostFavoritePlaceServiceParams} from "../types";

export function usePostFavoritePlaceMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({data, signal}: PostFavoritePlaceServiceParams) => 
      postFavoritePlace({data, signal}),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_PLACES]});
    },
  });
}
